import firebase from 'firebase'

var firebaseConfig = {
  apiKey: "AIzaSyBh80uyF1SErLnu4X-PDtHCYY6cCIK2Ti4",
  authDomain: "bimbim-pwa.firebaseapp.com",
  databaseURL: "https://bimbim-pwa.firebaseio.com",
  projectId: "bimbim-pwa",
  //storageBucket: "bimbim-pwa.appspot.com",
  messagingSenderId: "857735068270",
  appId: "1:857735068270:web:70afcd54ba2bb10260047f",
  //measurementId: "G-JD887LDXMM"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export default firebase;